const languageData = [
    {
        languageId: 'russian',
        locale: 'ru',
        name: 'Russian',
        icon: 'ru'
    }
];
export default languageData;
